/**
 * Utility helpers for Drawer Label.
 * This file contains shared pure helpers used by multiple screens, services, or wrappers.
 */
export function normalizeDrawerLabel(label: string | null | undefined): string {
  return String(label ?? '').replace(/\s*\+\s*/g, ' & ');
}
